import { features } from '@/mocks/home';

export default function FeaturesSection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            为什么选择 po18官网app
          </h2>
          <p className="mt-4 text-foreground-600 text-base max-w-2xl mx-auto">
            六大核心优势，为您打造极致的移动阅读体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-background-100 rounded-xl p-6 md:p-7 hover:bg-background-200/70 transition-colors duration-300 group cursor-default"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 group-hover:bg-accent-500 group-hover:text-background-50 transition-colors duration-300">
                <i className={`${feature.icon} text-2xl`}></i>
              </div>
              <h3 className="font-heading text-lg font-semibold text-foreground-950 mt-5 mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}